import React, { useState } from 'react';
import { Link, useLocation } from "react-router-dom";
import { Accordion, Dropdown } from 'react-bootstrap'
import routes from '../../utils/routes';
import { GiTakeMyMoney } from "react-icons/gi";
import { MdOutlineConnectWithoutContact } from "react-icons/md";
import { MdOutlineSettingsSuggest } from "react-icons/md";
import { TbHomeDollar } from "react-icons/tb";
import { AiOutlineAppstoreAdd } from "react-icons/ai";
import { FaShippingFast } from "react-icons/fa";
import { ImMakeGroup } from "react-icons/im";


const dashboardList = [
   { link: routes.dashboard, title: "Dashboard Overview" },
   { link: routes.sliders, title: "Manage Banner Sliders" },
]
const productList = [
   { link: routes.addProduct, title: "Create New Product" },
   { link: routes.productList, title: "View All Products" },
]
const order = [
   { link: routes.recentOrders, title: "View Recent Orders" },
   { link: routes.orders, title: "Order Management" },
]
const request = [
   { link: routes.users, title: "Manage Users" },
   { link: routes.contactUs, title: "Customer Support" },
]

const shipping = [
   { link: routes.locations, title: "Shipping Locations" },
   { link: routes.shipping, title: "Shipping Methods" },
]
const marketing = [
   { link: routes.marketingTools, title: "Marketing Tools" },
   { link: routes.SEOTools, title: "SEO Tools" },
   { link: routes.plugins, title: "Plugins" },
   { link: routes.socialMediaLinks, title: "Social Media Links" },
]
const settings = [
   { link: routes.brands, title: "Brands and Sponsors" },
   { link: routes.category, title: "Product Categories" },
   { link: routes.gallery, title: "Gallery" },
   // { link: routes.billings, title: "Billing" }, 
   { link: routes.settings, title: "System Settings" },
]

const ListItem = ({ list, updateSideBar }) => {
   const { pathname } = useLocation();
   return (
      <>
         <ul className="siderbar-options">
            {list?.map((data, index) => {
               return (
                  <li
                     className="text-capitalize"
                     key={index}
                     onClick={() => {
                        if (window.screen.width < 550) {
                           updateSideBar()
                        }
                     }}><Link className={pathname === data.link ? 'activeRoute' : 'text-muted'} to={data.link}>{data.title}</Link>
                  </li>

               )
            })}
         </ul >
      </>
   )
}

let DashBoardSideBar = ({ updateSideBar }) => {
   let [activeTab, setActiveTab] = useState(localStorage.getItem("activeSideBar") || 0)
   const updateActiveTab = (index) => {
      localStorage.setItem("activeSideBar", index);
      setActiveTab(index)
   }
   return (
      <div className="sidebar-navigation-wrapper">
         <Accordion defaultActiveKey={activeTab}>
            <Accordion.Item eventKey="0">
               <Accordion.Header
                  onClick={() => updateActiveTab(0)}
               >
                  <div className="nav-option">
                     <div className="icon">
                        <TbHomeDollar />
                     </div>
                     <div className="text">
                        <TbHomeDollar />  Dashboard</div>
                  </div>
               </Accordion.Header>
               <Accordion.Body>
                  <ListItem updateSideBar={updateSideBar} list={dashboardList} />
               </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
               <Accordion.Header
                  onClick={() => updateActiveTab(2)}
               >
                  <div className="nav-option">
                     <div className="icon"><GiTakeMyMoney /></div>
                     <div className="text"> <GiTakeMyMoney /> Orders</div>
                  </div>
               </Accordion.Header>
               <Accordion.Body>
                  <ListItem updateSideBar={updateSideBar} list={order} />
               </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
               <Accordion.Header
                  onClick={() => updateActiveTab(1)}
               >
                  <div className="nav-option">
                     <div className="icon"><AiOutlineAppstoreAdd /> </div>
                     <div className="text"> <AiOutlineAppstoreAdd /> Products</div>
                  </div>
               </Accordion.Header>
               <Accordion.Body>
                  <ListItem updateSideBar={updateSideBar} list={productList} />
               </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3">
               <Accordion.Header
                  onClick={() => updateActiveTab(3)}
               >
                  <div className="nav-option">
                     <div className="icon"><MdOutlineConnectWithoutContact /></div>
                     <div className="text"> <MdOutlineConnectWithoutContact /> Requests</div>
                  </div>
               </Accordion.Header>
               <Accordion.Body>
                  <ListItem updateSideBar={updateSideBar} list={request} />
               </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="4">
               <Accordion.Header
                  onClick={() => updateActiveTab(4)}
               >
                  <div className="nav-option">
                     <div className="icon"><FaShippingFast /> </div>
                     <div className="text"> <FaShippingFast /> Shipping</div>
                  </div>
               </Accordion.Header>
               <Accordion.Body>
                  <ListItem updateSideBar={updateSideBar} list={shipping} />
               </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="5">
               <Accordion.Header
                  onClick={() => updateActiveTab(5)}
               >
                  <div className="nav-option">
                     <div className="icon"><ImMakeGroup /> </div>
                     <div className="text"> <ImMakeGroup /> Marketing</div>
                  </div>
               </Accordion.Header>
               <Accordion.Body>
                  <ListItem updateSideBar={updateSideBar} list={marketing} />
               </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="6">
               <Accordion.Header
                  onClick={() => updateActiveTab(6)}
               >
                  <div className="nav-option">
                     <div className="icon"><MdOutlineSettingsSuggest /> </div>
                     <div className="text"> <MdOutlineSettingsSuggest /> Settings</div>
                  </div>
               </Accordion.Header>
               <Accordion.Body>
                  <ListItem updateSideBar={updateSideBar} list={settings} />
               </Accordion.Body>
            </Accordion.Item>
         </ Accordion>
      </div >
   )
}

export default DashBoardSideBar
